var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaceNeutralFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29 53.1666C42.3469 53.1666 53.1666 42.3469 53.1666 29C53.1666 15.6531 42.3469 4.83331 29 4.83331C15.6531 4.83331 4.83331 15.6531 4.83331 29C4.83331 42.3469 15.6531 53.1666 29 53.1666ZM19.9375 38.6666C19.9375 37.6656 20.749 36.8541 21.75 36.8541H36.25C37.251 36.8541 38.0625 37.6656 38.0625 38.6666C38.0625 39.6677 37.251 40.4791 36.25 40.4791H21.75C20.749 40.4791 19.9375 39.6677 19.9375 38.6666ZM24.1666 25.375C24.1666 27.377 23.0847 29 21.75 29C20.4153 29 19.3333 27.377 19.3333 25.375C19.3333 23.3729 20.4153 21.75 21.75 21.75C23.0847 21.75 24.1666 23.3729 24.1666 25.375ZM36.25 29C37.5847 29 38.6666 27.377 38.6666 25.375C38.6666 23.3729 37.5847 21.75 36.25 21.75C34.9153 21.75 33.8333 23.3729 33.8333 25.375C33.8333 27.377 34.9153 29 36.25 29Z",
    fill: "#3C3C3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceNeutralFilled);
export default __webpack_public_path__ + "static/media/face-neutral-filled.6bdf9b85.svg";
export { ForwardRef as ReactComponent };